import { render, staticRenderFns } from "./CostBreakdownItemModal.vue?vue&type=template&id=a32dc312&scoped=true&"
import script from "./CostBreakdownItemModal.vue?vue&type=script&lang=js&"
export * from "./CostBreakdownItemModal.vue?vue&type=script&lang=js&"
import style0 from "./CostBreakdownItemModal.vue?vue&type=style&index=0&id=a32dc312&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32dc312",
  null
  
)

export default component.exports